/**
 *
 * WidgetDates
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { DatePicker } from "antd"
import { get } from "lodash"
import { Link } from "react-router-dom"
import "./index.less"
import moment from "moment"
import EditScheduleDates from "../EditScheduleDates"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_btns, buttonAction_s } from "../Snowplow/config2"
// snowplow
let buttonAction_btn = (tipo) => {
  let data_button_prev = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: tipo,
    label: `Click a ${tipo}`,
    property: "button",
    value: LOCAL_USER_ID(),
  }
  buttonAction_s(data_button_prev)
}
/* eslint-disable react/prefer-stateless-function */
class WidgetDates extends React.Component {
  state = {
    openCalendar: false,
    editProgrammingModal: false,
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({ openCalendar: true })
    }, 1000)
  }

  componentDidUpdate = (prevProps) => {
    if (
      (this.props.showAlert != prevProps.showAlert && !this.props.showAlert) ||
      (this.props.showAlertResendSurveyToNews !=
        prevProps.showAlertResendSurveyToNews &&
        !this.props.showAlertResendSurveyToNews)
    ) {
      this.setState({ openCalendar: false }, () => {
        this.setState({ openCalendar: true })
      })
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  render() {
    const {
      progDates,
      progDates: { calendar = [] },
      datesProgramming,
      isLoadingDatesProgramming
    } = this.props
    return (
      <div>
        {!isLoadingDatesProgramming && (
          <div className="measurement-details-dates-header">
            <div>Programación de envío</div>
            <span />
            {[2, 3, 4].includes(this.props.measureStatus) && (
              <span
                onClick={() => {
                  this.setStateFrom("editProgrammingModal", true)
                  buttonAction_btns("Editar programacion de medicion")
                  window.Intercom('update', { hide_default_launcher: true})
                }}>
                Editar programación
              </span>
            )}
            {/* <Link to={`/measurement-create/${this.props.idSurvey}`}>Editar programación</Link> */}
          </div>
        )}
        <div className="measurement-details-dates-body">
          <div style={{ position: "relative" }}>
            <DatePicker
              style={{ width: 280 }}
              dropdownClassName="programming-dates-edit"
              showToday={false}
              open={this.state.openCalendar}
              value={moment(calendar[0], "DD-MM-YYYY")}
              dateRender={(currentDate, today) => {
                if (calendar.includes(currentDate.format("DD-MM-YYYY"))) {
                  let style = {}
                  if (
                    calendar[0] === currentDate.format("DD-MM-YYYY") ||
                    calendar[calendar.length - 1] ===
                      currentDate.format("DD-MM-YYYY")
                  ) {
                    style = {
                      backgroundColor: "#1890FF",
                      color: "#FFF",
                      width: 24,
                      borderRadius: 2,
                    }
                  }
                  return (
                    <div
                      className="ant-picker-cell-inner ant-picker-custom-inner-in-day"
                      style={{
                        color: "#1890FF",
                        backgroundColor: "#e6f7ff",
                        borderRadius: 0,
                        width: "100%",
                        ...style,
                      }}>
                      {currentDate.date()}
                    </div>
                  )
                }

                if (
                  currentDate.isBetween(
                    datesProgramming.date_start,
                    datesProgramming.date_end
                  )
                ) {
                  return (
                    <div
                      className="ant-picker-cell-inner"
                      style={{
                        backgroundColor: "#e6f7ff",
                        width: "100%",
                        borderRadius: 0,
                        lineHeight: "21px",
                      }}>
                      {currentDate.date()}
                    </div>
                  )
                }

                return (
                  <div className="ant-picker-cell-inner">
                    {currentDate.date()}
                  </div>
                )
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
            />
          </div>
          <div className="measurement-details-dates">
            <div className="measurement-details-dates-date">
              <span>Fecha programada de envío</span>
              <div>
                <span /> {get(progDates, "date_send.date_format", "...")}
              </div>
            </div>
            <div className="measurement-details-dates-date">
              <span>Fechas programadas de reenvío</span>
              {get(progDates, "date_resend", []).map((item, index) => {
                return (
                  <div key={index}>
                    <span className={`${item.sended ? "" : "no-sended"}`} />
                    {item.date_format}
                  </div>
                )
              })}

              {get(progDates, "date_resend", []).length === 0 && (
                <p
                  style={{
                    color: "rgba(0,0,0,0.25)",
                    marginTop: 18,
                    textAlign: "center",
                    fontSize: 12,
                  }}>
                  No hay fechas programadas de reenvío.
                </p>
              )}
            </div>
          </div>
        </div>
        <EditScheduleDates
          {...this.props}
          modalOpen={this.state.editProgrammingModal}
          setStateFrom={this.setStateFrom}
        />
      </div>
    )
  }
}

WidgetDates.propTypes = {}

export default WidgetDates
